//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentList from '@/components/common/contentList';

export default {
  components: {
    ContentList,
  },
  props: {
    teachers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperConfig: {
        spaceBetween: 20,
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        breakpoints: {
          768: {
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },
      },
    };
  },
};
